import { MISSION_PREFERENCES_OPTALL, CPM_NO, CPM_YES } from "constants/cpm";
import { consentOptions } from "constants/PreferencesConst";
import customFetch from "utils/customFetch";
import { getAuthUrl } from "utils/env";

// NOTE: do NOT prefix this with PUBLIC_URL ("/login-ui"). That path matches
// nginx's `location ^~ /login-ui/ { try_files ... /login-ui/index.html; }`
// block, so instead of proxying to the CPM backend it silently returns the
// SPA's index.html (200 OK, but not JSON) — response.json() then throws and
// the mission consent checkboxes never render. The real backend is reached
// via nginx's `location /preferences/` block, which requires
// PREFERENCES_SERVICE_URL to be set (see bosun.yaml / env-configs overrides).
const ENDPOINTS = {
  GET_CONSENTS: "/preferences/consents",
};
const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export function getConsents(email) {
  let encodedEmail = encodeURIComponent(email);
  const requestOptions = {
    method: "GET",
    headers: headers,
  };

  return customFetch(
    getAuthUrl(`${ENDPOINTS.GET_CONSENTS}?email=${encodedEmail}`),
    requestOptions
  );
}

function buildConsentsRequestToSave(formData, missionId, touchpoint) {
  const missionConfig = JSON.parse(sessionStorage.getItem(missionId));
  const consentToSave = {
    mission_code: missionConfig.cpm_mission_code,
    touchpoint: touchpoint,
  };
  if (formData[MISSION_PREFERENCES_OPTALL] === CPM_NO) {
    consentToSave.consents = [];
    // eslint-disable-next-line no-unused-vars
    for (const [i, element] of consentOptions.entries()) {
      consentToSave.consents.push({
        mission_name: element.key,
        consent: formData[element.key] == null ? "N" : formData[element.key],
      });
    }
  } else if (formData[MISSION_PREFERENCES_OPTALL] === CPM_YES) {
    consentToSave.consent = "Y";
  }
  return consentToSave;
}

export const cpmService = {
  getConsents,
  buildConsentsRequestToSave,
};
